<nz-spin [nzSpinning]="isLoading"></nz-spin>

@if (!isLoading && data) {
  <div class="row">
    <div class="col col-lg-12">
      <table class="table table-borderless mb-0">
        <tr>
          <td class="fs-12 pt-1 pb-3 w-120">TagName:</td>
          <td class="fs-12 pt-1 pb-3">
            @for (tag of data.tags; track tag + '-' + $index; let i = $index) {
              <span class="clickable" (click)="onDataCardDrawerOpen(tag)">
                {{ tag }}
              </span>
              @if (i + 1 < data.tags.length) {
                ,
              }
            }
          </td>
        </tr>

        <tr>
          <td class="fs-12 pt-1 pb-0 w-120">Created:</td>
          <td class="fs-12 pt-1 pb-0">{{ data?.created_date | niceDate : '-' : true }}</td>
        </tr>
        <tr>
          <td class="fs-12 pt-1 pb-3 w-120">Closed:</td>
          <td class="fs-12 pt-1 pb-3">{{ data?.closed_date | niceDate : '-' : true }}</td>
        </tr>

        <tr>
          <td class="fs-12 pt-1 pb-0 w-120">ID:</td>
          <td class="fs-12 pt-1 pb-0">
            @if (data.url) {
              <a [href]="data.url" [title]="data.notification" target="_blank" class="clickable text-success mt-3">
                {{ data?.notification | nullAsWhatever : '-' }}
              </a>
            } @else {
              {{ data?.notification | nullAsWhatever : '-' }}
            }
          </td>
        </tr>
        <tr>
          <td class="fs-12 pt-1 pb-3 w-120 align-top">Title:</td>
          <td class="fs-12 pt-1 pb-3">{{ data?.title | nullAsWhatever : '-' }}</td>
        </tr>

        <tr>
          <td class="fs-12 pt-1 pb-0 w-120 align-top">Fault Code:</td>
          <td class="fs-12 pt-1 pb-0">{{ data?.fault_code | nullAsWhatever : '-' }}</td>
        </tr>
        <tr>
          <td class="fs-12 pt-1 pb-0 w-120 align-top">Description:</td>
          <td class="fs-12 pt-1 pb-0">
            <span [innerHTML]="data?.description | normalizeNewLines | newLineBreaker | nullAsWhatever : '-'"></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
}
